"use strict";
/**
 * Created by rouven on 12.04.17.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
// @ts-ignore
var react_symbol_1 = __importDefault(require("@wikom/react-symbol"));
/**
 * Loading spinner with optional loading message
 *
 * @param title - Message displayed when loading is rendered
 */
var Loading = function (_a) {
    var _b = _a.title, title = _b === void 0 ? 'Ihre Daten werden geladen...' : _b;
    return react_1["default"].createElement("div", { className: "pageWaiter" },
        react_1["default"].createElement("div", { className: "pageWaiter-inner" },
            react_1["default"].createElement(react_symbol_1["default"], { symbol: "cog", spinning: true })),
        react_1["default"].createElement("p", { className: "pageWaiter-note" }, title));
};
exports["default"] = Loading;
